import { metaAccount } from '@/router/meta-config'
const permissionKey = 'ACCOUNT'

export default [
  {
    path: '/accounts',
    name: 'page-accounts',
    component: () => import('@/pages/accounts'),
    meta: {
      ...metaAccount,
      permissionKey
    }
  },
  {
    path: '/account/new',
    name: 'page-account-new',
    component: () => import('@/pages/account'),
    meta: {
      ...metaAccount,
      permissionKey
    }
  },
  {
    path: '/account/:id',
    name: 'page-account',
    component: () => import('@/pages/account'),
    props: (route) => ({ id: Number(route.params.id) }),
    meta: {
      ...metaAccount,
      permissionKey
    }
  }
]
